import { createSelector } from "@reduxjs/toolkit";
import { SharedState } from "../SharedProvider";
import {
  EnvironmentPollution,
  EnvironmentPollutionType,
} from "../../interfaces/robot/cleaning-configurations/environment-pollution";

export const selectIsRobotConnected = (state: SharedState) => state.robotConfigurations.isRobotConnected;

export const selectRobotApiConfigs = (state: SharedState) => state.robotConfigurations.robotApiConfiguration.data;
export const selectRobotApiConfigsRestSet = (state: SharedState) => state.robotConfigurations.robotApiConfiguration.rest;
export const selectRobotRelayGateApiConfigs = (state: SharedState) => state.robotConfigurations.relayGateApiConfiguration;
export const selectSystemSettings = (state: SharedState) => state.robotConfigurations.systemSettings;
export const selectSystemSettingsData = (state: SharedState) => state.robotConfigurations.systemSettings.data;
export const selectSystemSerialData = (state: SharedState) => state.robotConfigurations.systemSerialData;
export const selectGlobalCleaningConfiguration = (state: SharedState) =>
  state.robotConfigurations.paramList.data?.cleaningConfiguration;
export const selectGlobalMapRulesConfiguration = (state: SharedState) =>
  state.robotConfigurations.paramList.data?.mapRulesConfiguration;
export const selectParamList = (state: SharedState) => state.robotConfigurations.paramList.data;
export const selectParamListRestState = (state: SharedState) => state.robotConfigurations.paramList.rest;
export const selectExcludedDates = (state: SharedState) => state.robotConfigurations.excludedDates;

export const selectEnvironmentPollutions = (state: SharedState) =>
  state.robotConfigurations.cleaningConfiguration.environmentPollution.data;
export const selectEnvironmentPollutionRestState = (state: SharedState) =>
  state.robotConfigurations.cleaningConfiguration.environmentPollution.rest;
export const selectCustomEnvironmentPollution = createSelector(
  [selectEnvironmentPollutions],
  (pollutions): EnvironmentPollution | null =>
    (pollutions ?? []).find((p) => p.type === EnvironmentPollutionType.Custom) ?? null
);

export const selectNavLocalPlannerData = (state: SharedState) => state.robotConfigurations.nav.localPlanner;
export const selectNavTasksData = (state: SharedState) => state.robotConfigurations.nav.tasks;

export const selectRobotCleaningCommandButtons = (state: SharedState) => state.robotConfigurations.buttonConfiguration;
export const selectRobotModel = (state: SharedState) =>
  state.robotConfigurations.systemSerialData.data?.robotVersion ?? state.robotConfigurations.robotVersion;
export const selectRobotRswSoftwareVersion = (state: SharedState) => state.robotConfigurations.robotSoftwareVersion?.rswSoftwareVersion;
